import createContext from '../support/helpers/createContext';

type CurrencyContext = {
  currency: string;
};

let [useCurrencyContext, CurrencyProvider] = createContext<CurrencyContext>();

export { useCurrencyContext, CurrencyProvider };
